import './qr.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ProfileQr extends Component {

    render() {
    	if (!this.props.src) return null;
        return (
            <div className="ProfileQr">
                <img src={this.props.src} alt="Your QR Code" />
            </div>
        );
    }
}

ProfileQr.propTypes = {
    src: PropTypes.string
};

export default ProfileQr;